const CONTACTS_IMAGE_WIDTH = 30;
const CONTACTS_IMAGE_HEIGHT = 30;
const CONTACTS_IMAGE_QUALITY = 80;

export { CONTACTS_IMAGE_WIDTH, CONTACTS_IMAGE_HEIGHT, CONTACTS_IMAGE_QUALITY };
